import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrientationPage } from './pages/orientation.page';
import { modalGuard } from '../../../core/guards/modal/modal.guard';

const routes: Routes = [
  {
    path: '',
    component: OrientationPage,
    canDeactivate: [modalGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrientationPageRoutingModule {}
